import { render, staticRenderFns } from "./LateralNavConfiguration.vue?vue&type=template&id=215356de&scoped=true&"
import script from "./LateralNavConfiguration.vue?vue&type=script&lang=js&"
export * from "./LateralNavConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./LateralNavConfiguration.vue?vue&type=style&index=0&id=215356de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215356de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
})
